import React from 'react';
//import css from './css.module.less';
import { Input } from '@/src/components/Antd';
import BlockTitle from '@/src/components/Modules-revamp/BlockTitle';
import { get } from 'lodash';
import CountWordsWithFormItem from 'src/components/CountWords/CountWordsWithFormItem';
import FocusPoint from 'src/components/ImageFocusPointEdit';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import Wrapper from 'src/components/Modules-revamp/BlockWrapper';
import {
  Field,
  antdErrorDisplayAdaptor,
  itemWrapperErrorDisplayAdaptor,
} from 'src/components/RcForm';
import Uploader from 'src/constrains/SingleImageUploader';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  ContentSetting,
  contentSetting,
  image,
  imageSetting,
  title,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditor404Page-revamp/constant';
import { checkContentSetting } from 'src/pages/SalesChannelContentEditor/SalesChannelEditor404Page-revamp/validator';
import { sectionProps } from 'src/tools/constant';
import { i18nGet } from 'src/tools/tools';
import { EPreviewSize } from '@/src/types/common/SalesChannel';
import { editable } from '@/src/tools/contentModulesFieldName';
import { getEditableStatus } from '../../SalesChannelEditorAllProductPage-revamp/util';
import {
  contentSettingFields,
  contentSettingResetFields,
  contentSettingResponsiveResetFields,
} from '../fields';
import { isPrimaryLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import { useSelector } from 'react-redux';
const { checkImage, checkText, checkAll } = checkContentSetting();

const imageN = [contentSetting, image];
const focusN = [...imageN, imageSetting];
const textN = [contentSetting, title];

const CS = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { breakpoint, disabled } = props;
  const isPc = breakpoint === EPreviewSize.WIDE;
  const isOnPrimaryLanguage = useSelector(isPrimaryLanguage());

  const handleOnResetTabletAndMobile = () => {
    const isTabletEditing = props.tabletForm.getFieldValue([
      `${ContentSetting}_${editable}`,
    ]);
    const isMobileEditing = props.mobileForm.getFieldValue([
      `${ContentSetting}_${editable}`,
    ]);
    if (isTabletEditing) {
      props.handleOnSectionReset(
        contentSettingResetFields,
        EPreviewSize.TABLET,
      );
    } else {
      props.handleOnSectionReset(
        contentSettingResetFields,
        EPreviewSize.TABLET,
      );
      // props.handleOnSectionReset(contentSettingFields, EPreviewSize.TABLET);
    }
    if (isMobileEditing) {
      props.handleOnSectionReset(
        contentSettingResetFields,
        EPreviewSize.MOBILE,
      );
    } else {
      props.handleOnSectionReset(
        contentSettingResetFields,
        EPreviewSize.MOBILE,
      );
      //props.handleOnSectionReset(contentSettingFields, EPreviewSize.MOBILE);
    }
  };

  const handleOnReset = () => {
    props.handleOnSectionReset(
      isPc ? contentSettingFields : contentSettingResponsiveResetFields,
      breakpoint,
    );
    if (isPc) {
      handleOnResetTabletAndMobile();
    }
  };
  return (
    <Wrapper id={ContentSetting} breakpoint={breakpoint}>
      <Field shouldUpdate>
        {(_, meta, { getFieldValue }) => {
          const is_editable =
            getEditableStatus(getFieldValue, ContentSetting, breakpoint) &&
            isOnPrimaryLanguage;
          return (
            <BlockTitle
              id={ContentSetting}
              title={getI18n('salesChannelContent.index.contentSetting')}
              breakpoint={breakpoint}
              onReset={() => handleOnReset()}
              onCopy={() =>
                props.handleOnSectionCopy(contentSettingFields, breakpoint)
              }
              headerErrorDependencies={[[contentSetting]]}
              validator={(data) => {
                const menu = get(data, contentSetting);
                return checkAll(menu);
              }}
              dotsFunction={[
                {
                  onClick: () => {
                    handleOnReset();
                  },
                  key: 'Reset',
                  body: getI18n('general.resetSetting'),
                  isDangerous: true,
                },
              ]}
              dotsDisabled={!is_editable}
            />
          );
        }}
      </Field>

      <Section {...sectionProps}>
        <Field shouldUpdate>
          {(props, meta, { getFieldValue }) => {
            const is_editable = getEditableStatus(
              getFieldValue,
              ContentSetting,
              breakpoint,
            );
            return (
              <>
                <Field
                  name={imageN}
                  dependencies={[`${ContentSetting}_${editable}`]}
                  rules={[
                    {
                      validator: async (rules: any, value: any) => {
                        const res = checkImage(value);

                        const hasError = get(res, 'hasError');
                        const errors = get(res, 'errors');
                        if (hasError) {
                          return Promise.reject(
                            new Error((errors || []).join(',')),
                          );
                          //</ItemWrapper>throw Error((errors || []).join(','));
                        }
                      },
                    },
                  ]}>
                  {(
                    props,
                    meta,
                    { getFieldValue, setFields, setFieldsValue },
                  ) => {
                    const e = itemWrapperErrorDisplayAdaptor(meta);
                    return (
                      <ItemWrapper
                        title={getI18n('general.tools_helper.image')}
                        bottomTitle={`${getI18n(
                          'general.allowedfiletypes',
                        )}: jpeg, gif, png`}
                        size='small'
                        {...e}>
                        <Uploader
                          height={180}
                          {...props}
                          disabled={disabled || !is_editable}
                        />
                      </ItemWrapper>
                    );
                  }}
                </Field>
                <Field
                  shouldUpdate={(p, c) => {
                    return get(p, imageN) !== get(c, imageN);
                  }}>
                  {(
                    props,
                    meta,
                    { getFieldValue, setFields, setFieldsValue },
                  ) => {
                    const image = getFieldValue(imageN);
                    return (
                      <Field name={focusN}>
                        {(props, meta) => {
                          //const value = props.value;
                          const onChange = props.onChange;
                          return (
                            <FocusPoint
                              image={image}
                              disable={disabled || !is_editable}
                              onChange={(image) => {
                                onChange(get(image, 'image.imageSetting'));
                              }}
                            />
                          );
                        }}
                      </Field>
                    );
                  }}
                </Field>
              </>
            );
          }}
        </Field>
        <ItemWrapper
          title={getI18n('general.content.text')}
          rightPart={<CountWordsWithFormItem keyName={textN} maxCount={40} />}>
          <Field
            name={textN}
            rules={[
              {
                validator: async (rules: any, value: any) => {
                  const res = checkText(value);

                  const hasError = get(res, 'hasError');
                  const errors = get(res, 'errors');
                  if (hasError) {
                    return Promise.reject(new Error((errors || []).join(',')));
                    //</ItemWrapper>throw Error((errors || []).join(','));
                  }
                },
              },
            ]}>
            {(props, m) => {
              const eP = antdErrorDisplayAdaptor(m);

              return (
                <Input
                  disabled={breakpoint !== EPreviewSize.WIDE}
                  maxLength={40}
                  size='large'
                  {...props}
                  {...m}
                  {...eP}
                />
              );
            }}
          </Field>
        </ItemWrapper>
      </Section>
    </Wrapper>
  );
};
export default CS;
